import { FormItem, FormValue } from "@/components/form-area/type";
import { Apply, VehicleApply } from "@/api";
import { getFileSizeText } from "@/common/tool";
import { getFileTypeIcon, getUrlFileName } from "@/ui/upload/file";
import { FileItem, FileValueItem } from "@/ui/upload/type";
import { CarForm } from "@/components/car/type";
import { isArray, getDate } from "@/common/tool";

export interface DetailItem {
  key: string;
  label: string;
  value: unknown;
  component?: string;
}

export interface DetailItem {
  key: string;
  label: string;
  value: unknown;
  component?: string;
}

export interface ApplyMessage {
  id: number;
  temple_id: number;
  type: number;
  apply_id: number;
  apply_status: number;
  approval_type: number;
  book_id: string;
  deal_user_id: string | null;
  is_complete: number;
  node_id: string;
  note: string | null;
  select: string | null;
  create_time: string;
  update_time: string;
}

export interface FlowStatusItem {
  approval_type: number;
  detail: {
    [key: string]: ApplyMessage;
  };
  ids: string[];
  node_id: string;
  node_status: number;
  type: number;
}

export interface Status {
  value: number;
  title: string;
  vehicleStatus: number;
}

export interface CarItem {
  number: string;
  name: string;
  tel: string;
}

export type StatusItem = Pick<Status, "title" | "vehicleStatus">;

export const statusList: Array<Status> = [
  {
    value: 1,
    title: "审批中",
    vehicleStatus: 0,
  },
  {
    value: 2,
    title: "已驳回",
    vehicleStatus: 2,
  },
  {
    value: 3,
    title: "已撤销",
    vehicleStatus: 2,
  },
  {
    value: 4,
    title: "已通过",
    vehicleStatus: 1,
  },
  {
    value: 5,
    title: "已完成",
    vehicleStatus: 1,
  },
];

// 申请详情-流程列表
export const showStatusList: Array<StatusItem> = [
  {
    title: "审批中",
    vehicleStatus: 0,
  },
  {
    title: "已通过",
    vehicleStatus: 1,
  },
  {
    title: "已驳回",
    vehicleStatus: 2,
  },
];

export const getApplyStatusText = function (status: number) {
  const res = statusList.find((s) => s.value == status);
  return res ? res.title : "";
};
export const changeApplyStatusToVehicleStatus = function (status: number) {
  const res = statusList.find((s) => s.value == status);
  return res ? res.vehicleStatus : 0;
};
export const getApplyRejectReason = function (apply: Apply) {
  let res = "";
  if (apply.status == 2 && apply.flow_status) {
    try {
      const flow: FlowStatusItem[] = JSON.parse(apply.flow_status);
      for (let i = 0, l = flow.length; i < l; i++) {
        const item = flow[i];
        // 驳回节点
        if (item.node_status == 2 && item.detail) {
          for (const key in item.detail) {
            const user = item.detail[key];
            if (user.apply_status == 2) {
              res = user.note || "";
              break;
            }
          }
          break;
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
  return res;
};

export const getFormValue = function (item: FormItem, detail: FormValue) {
  const val = detail[item.key];
  let value: unknown = val;
  if (val) {
    switch (item.component) {
      // 上传值兼容处理
      case "upload": {
        let list: FileValueItem[] = [];
        if (typeof value === "string") {
          list = [{ url: value, fileName: getUrlFileName(value) }];
        } else if (value instanceof Array) {
          list = [...value] as FileValueItem[];
        }
        const files: Array<FileValueItem> = list.map((item) => {
          const f: FileItem = {
            ...item,
            name: item.fileName,
            type: getFileTypeIcon(item.url),
            state: "success",
          };
          if (item.size) {
            f.sizeText = getFileSizeText(item.size);
          }
          return f;
        });
        value = files.length > 0 ? files : null;
        break;
      }
      case "half-date": {
        const temp = val as Array<string | number>;
        if (String(temp[1]).indexOf(":") > -1) {
          // 兼容时间为hh:mm
          value = temp.join(" ");
        } else {
          value = `${temp[0]} ${["上午", "下午"][Number(temp[1])]}`;
        }
        break;
      }
      case "input":
        if (item.suffix) {
          value = String(value) + item.suffix;
        }
        break;
    }
  }
  return value;
};

export const constructForm = function (form: DetailItem[], detail: FormValue, config: FormItem[]) {
  const list = [...config];
  list.forEach((item) => {
    const value = getFormValue(item, detail);
    if (item.component === "car" && isArray(value)) {
      const person = {
        key: "person",
        label: "",
        value: value as CarItem[],
        component: item.component,
      };
      const car = {
        key: item.key,
        label: "车牌号",
        value: (value as Array<CarForm>).map((item: CarForm) => item.num).join("  "),
        component: item.component,
      };
      form.push(person, car);
    } else {
      form.push({
        key: item.key,
        label: item.label,
        value,
        component: item.component,
      });
    }
  });
};

export const getApplyBrief = function (apply: VehicleApply) {
  const brief: DetailItem[] = [];
  if (apply.detail && apply.temp_snap) {
    try {
      brief.push({
        key: "create_time",
        label: "提交时间",
        value: getDate(apply.create_time)?.pattern("yyyy-MM-dd HH:mm"),
        component: "date-time",
      });
      const detail = JSON.parse(apply.detail);
      if (apply.temp_snap) {
        const conf: FormItem[] = JSON.parse(apply.temp_snap);
        conf.forEach((c) => {
          if (c.show_in_list) {
            const value = getFormValue(c, detail);
            brief.push({
              key: c.key,
              label: c.label,
              value,
              component: c.component,
            });
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  return brief;
};
